// extracted by mini-css-extract-plugin
export default {"userDetailTitle":"SelectDropdown_userDetailTitle__Z6WIs","error":"SelectDropdown_error__1JuPv","dropdown":"SelectDropdown_dropdown__FI7Ti"};